"use client";

import {
    Pagination,
    PaginationContent,
    PaginationItem,
    PaginationPrevious,
    PaginationLink,
    PaginationEllipsis,
    PaginationNext,
} from "@/components/ui/pagination";
import { Skeleton } from "@/components/ui/skeleton";
import { IUserData } from "@/types";

export function BlogPostSkeletonBlock({ account }: { account: IUserData }) {
    return (
        <div
            className={`z-50 flex w-full flex-col gap-1 ${account.theme.button_rounded == "rounded-full" ? "rounded-xl" : account.theme.button_rounded}`}
            style={{
                backgroundColor: account.theme.button,
                color: account.theme.text_col_heading,
            }}
        >
            <div className="relative flex h-full min-h-full items-start gap-2">
                <Skeleton
                    className={`h-full w-32 object-cover object-center md:h-36 md:w-48 ${account.theme.button_rounded == "rounded-full" ? "rounded-xl" : account.theme.button_rounded} bg-user-primary-color`}
                />
                <div className="relative flex h-full flex-col gap-1 pr-6 pt-3">
                    <Skeleton className="h-6 w-96 bg-user-primary-color" />
                    <Skeleton className="h-3 w-96 bg-user-primary-color" />
                    <Skeleton className="h-3 w-96 bg-user-primary-color" />
                    <Skeleton className="h-3 w-96 bg-user-primary-color" />
                    <Skeleton className="h-3 w-96 bg-user-primary-color" />
                    <div className="flex items-center justify-between pt-1">
                        <div className="noscroll relative z-50 line-clamp-1 flex items-center gap-2 overflow-x-scroll">
                            <Skeleton className="h-4 w-8 rounded-xl bg-user-primary-color" />
                            <Skeleton className="h-4 w-8 rounded-xl bg-user-primary-color" />
                        </div>
                        <Skeleton className="h-3 w-24 bg-user-primary-color" />
                    </div>
                </div>
            </div>
        </div>
    );
}
export function BlogPostSkeletonPaginate({ account }: { account: IUserData }) {
    return (
        <>
            <BlogPostSkeletonBlock account={account} />
            <BlogPostSkeletonBlock account={account} />
            <BlogPostSkeletonBlock account={account} />
            <Pagination>
                <PaginationContent>
                    <PaginationItem>
                        <PaginationPrevious href="#" aria-disabled={true} />
                    </PaginationItem>
                    <PaginationItem>
                        <PaginationEllipsis />
                    </PaginationItem>
                    <PaginationItem>
                        <PaginationNext aria-disabled={true} href="#" />
                    </PaginationItem>
                </PaginationContent>
            </Pagination>
        </>
    );
}
